import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal"]

  connect() {
    // Reset form when modal is closed
    this.modalTarget.addEventListener('turbo:submit-end', (event) => {
      if (event.detail.success) {
        this.close()
        this.resetForm()
      }
    })
  }

  open() {
    this.modalTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
  }

  close(event) {
    // Don't close if clicking inside the modal content (unless it's the close button)
    if (event && event.target !== event.currentTarget && !event.currentTarget.dataset.action?.includes("close")) {
      return
    }

    this.modalTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
  }

  resetForm() {
    const form = this.modalTarget.querySelector('form')
    if (form) form.reset()
  }
}